import {
  Button,
  Carousel,
  Checkbox,
  FileInput,
  Select as FBSelect,
  Tabs,
  TextInput,
  Tooltip,
} from "flowbite-react";
import Select from "react-select";

import React, { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import Loader from "../Common/Loader";
import Editor from "../Common/Editor";
import blankImage from "../../Assets/NoPhoto.jpg";
import { Link, useNavigate, useParams } from "react-router-dom";
import { fetchCategories } from "../../Actions/CommonFields";
import { useAppDispatch, useAppSelector } from "../../Reducers/store";
import { HiEye, HiPencil, HiPencilAlt } from "react-icons/hi";
import { Equipment } from "../../Models/Equipment";
import EquipmentApi from "../../Api/EquipmentApi";
import { formatNumbers, onlyNumberInput } from "../../Utils";
import { MdCancel, MdCheckCircle } from "react-icons/md";
import CommonApi from "../../Api/CommonApi";
import { File as ImageFile } from "../../Models/File";
import {
  EquipmentTypeEnums,
  EquipmentTypeStringEnums,
} from "../../Models/EquipmentTypeEnums";
import EquipmentFeatureList from "./EquipmentFeatureList";
import { SubCategory } from "../../Models/SubCategory";
import EquipmentFiles from "./EquipmentFiles";
import { FileTypeEnums } from "../../Models/FileType";
import { SubCategoryCustom } from "../../Models/SubCategoryCustom";
import { SelectOption } from "../../Models/SelectOption";
import EquipmentImages from "./EquipmentImages";
import EquipmentVideoList from "./EquipmentVideoList";
import ManufacturerApi from "../../Api/ManufacturerApi";
import { Manufacturer } from "../../Models/Manufacturer";

export default function EditEquipment({
  equipmentType,
}: {
  equipmentType: EquipmentTypeEnums;
}) {
  const { id } = useParams();
  const [quillValue, setQuillValue] = useState("");
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { categories } = useAppSelector((state) => state.commonFields);
  const [equipmentData, setEquipmentData] = useState<Equipment | null>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const [imageFiles, setImageFiles] = useState<ImageFile[]>([]);
  const [subcategories, setsubcategories] = useState<SubCategoryCustom[]>([]);
  const [manufacturers, setManufacturerData] = useState<
    Manufacturer[] | null
  >();
  const [selectedSubCategories, setselectedSubCategories] = useState<
    SelectOption[] | null
  >(null);
  const [formData, setFormData] = useState<Equipment>({
    id: 0,
    manufacturerId: null,
    rimssId: null,
    number: "",
    price: null,
    cost: null,
    productId: null,
    productSource: null,
    locationId: null,
    oemvendor: null,
    oemdivision: null,
    priceBook: null,
    description: null,
    fullDescription: null,
    upc: null,
    sku: null,
    primaryBin: null,
    quantityOnHand: null,
    quantityCommitted: null,
    quantityOnOrder: null,
    quantityCommittedOnOrder: null,
    averageCost: null,
    manufacturerList: null,
    replacementCost: null,
    productClass: null,
    productCategory: null,
    productGroup: null,
    packageMultiple: null,
    height: null,
    width: null,
    depth: null,
    weight: null,
    associationType: null,
    tradePrice: null,
    listPrice: null,
    special1Price: null,
    special2Price: null,
    special3Price: null,
    inactive: null,
    pricingUoM: null,
    categoriesString: null,
    primaryImageURL: "",
    equipmentFeatures: null,
    equipmentSubCategories: [],
    files: null,
    manufacturer: null,
    equipmentVideos: [],
  });
  const [fileList, setFile] = useState<FileList | null>();

  const getEquipment = () => {
    if (id) {
      setIsLoading(true);
      EquipmentApi.getEquipment(id)
        .then((res) => {
          setEquipmentData(res.data);

          setQuillValue(res.data.fullDescription ?? "");
          if (res.data.equipmentSubCategories) {
            setselectedSubCategories(
              res.data.equipmentSubCategories?.map((object) =>
                Object.assign(object, {
                  label: object.subCategory!.name,
                  value: object.subCategoryId!,
                })
              )
            );
          }
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    } else {
      setEquipmentData(null);
    }
  };

  const getSubcategories = () => {
    setIsLoading(true);
    return CommonApi.getSubCategoriesCustom()
      .then((res) => {
        setsubcategories(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        toast.error("Error");
        setIsLoading(false);
      });
  };

  const subcategoryList = useMemo(() => {
    const list = subcategories.map((t) => ({
      label: t.name,
      value: t.number!,
    })) as SelectOption[];
    return [...list];
  }, [subcategories]);

  const getReferences = async () => {
    getSubcategories();
    getManufacturers();
  };

  const getManufacturers = () => {
    setIsLoading(true);
    ManufacturerApi.getManufacturerListWG()
      .then((res) => {
        setManufacturerData(
          res.data.filter(
            (item) =>
              item.rimssOemvendorNumber?.startsWith("1") && item.active == true
          )
        );
        fetchCategories();
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getEquipment();
  }, [id]);

  useEffect(() => {
    // if (equipmentData && userModel && id) {
    //   if (userModel.userLevelId !== UserLevelNames.SuperAdmin) {
    //     if (
    //       userModel.memberId !== equipmentData.memberId ||
    //       (userModel.memberId === equipmentData.memberId &&
    //         userModel.id !== Number(id) &&
    //         userModel.userLevelId !== UserLevelNames.MemberAdmin)
    //     ) {
    //       toast.error('You do not have access to this page');
    //       navigate(-1);
    //     }
    //   }
    // }
    handleSetInitialValues();
  }, [equipmentData]);

  useEffect(() => {
    getReferences();
  }, []);

  const handleSetInitialValues = () => {
    const values = equipmentData
      ? {
          ...equipmentData,
          price: equipmentData.price ? formatNumbers(equipmentData.price) : "",
          cost: equipmentData.cost ? formatNumbers(equipmentData.cost) : "",
        }
      : {
          id: 0,
          manufacturerId: null,
          rimssId: null,
          number: "",
          price: null,
          cost: null,
          productId: null,
          productSource: null,
          locationId: null,
          oemvendor: null,
          oemdivision: null,
          priceBook: null,
          description: null,
          fullDescription: null,
          upc: null,
          sku: null,
          primaryBin: null,
          quantityOnHand: null,
          quantityCommitted: null,
          quantityOnOrder: null,
          quantityCommittedOnOrder: null,
          averageCost: null,
          manufacturerList: null,
          replacementCost: null,
          productClass: null,
          productCategory: null,
          productGroup: null,
          packageMultiple: null,
          height: null,
          width: null,
          depth: null,
          weight: null,
          associationType: null,
          tradePrice: null,
          listPrice: null,
          special1Price: null,
          special2Price: null,
          special3Price: null,
          inactive: null,
          pricingUoM: null,
          categoryId: null,
          subCategoryId: null,
          primaryImageURL: "",

          category: null,
          equipmentFeatures: null,
          equipmentSubCategories: [],
          files: null,
          manufacturer: null,
          subCategory: null,
          equipmentVideos: [],
        };

    if (values.files) {
      setImageFiles(
        values.files.filter(
          (x) => x.fileTypeId === FileTypeEnums.Photo
        ) as ImageFile[]
      );
    }
    setFormData(values as Equipment);
  };

  const handleChangeCurrencyInput = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, value } = e.target;
    const formattedValue = formatNumbers(value);
    setFormData((prevData) => ({ ...prevData, [name]: formattedValue }));
  };

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleChangeCheckboxInput = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, checked } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: checked }));
  };

  const handleChangeTextArea = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value ? Number(value) : null, // Convert back to number or null
    }));
  };

  function handleImageChange(event: React.ChangeEvent<HTMLInputElement>) {
    if (event.currentTarget.files) {
      setFile(event.currentTarget.files);
    } else {
      setFile(null);
    }
  }

  function cleanValues(formData: Equipment) {
    formData.price = Number((formData.price ?? 0).toString().replace(",", ""));
    formData.cost = Number((formData.cost ?? 0).toString().replace(",", ""));
    formData.averageCost = Number(
      (formData.averageCost ?? 0).toString().replace(",", "")
    );
    formData.manufacturerList = Number(
      (formData.manufacturerList ?? 0).toString().replace(",", "")
    );
    formData.replacementCost = Number(
      (formData.replacementCost ?? 0).toString().replace(",", "")
    );
    formData.tradePrice = Number(
      (formData.tradePrice ?? 0).toString().replace(",", "")
    );
    formData.listPrice = Number(
      (formData.listPrice ?? 0).toString().replace(",", "")
    );
    formData.special1Price = Number(
      (formData.special1Price ?? 0).toString().replace(",", "")
    );
    formData.special2Price = Number(
      (formData.special2Price ?? 0).toString().replace(",", "")
    );
    formData.special3Price = Number(
      (formData.special3Price ?? 0).toString().replace(",", "")
    );
  }

  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    setButtonDisabled(true);
    let equipmentUpdated = false;
    let imageUpdated = false;
    let subCategoriesUpdates = false;
    formData.fullDescription = quillValue;
    try {
      setIsLoading(true);
      cleanValues(formData);
      await EquipmentApi.addUpdateEquipment(formData)
        .then((res) => {
          if (res.data.success) {
            equipmentUpdated = true;
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          toast.error("Error: " + err);
          setIsLoading(false);
        });
      if (fileList) {
        const fd = new FormData();
        Array.from(fileList).forEach((file) => {
          fd.append("file", file);
        });
        fd.append("equipmentId", formData.id.toString());
        await EquipmentApi.uploadEquipmentImage(fd)
          .then((res) => {
            if (res.data.success) {
              imageUpdated = true;
            }
          })
          .catch((err) => {
            toast.error("Image Error: " + err);
          });
      } else {
        imageUpdated = true;
      }
      if (selectedSubCategories) {
        await EquipmentApi.updateEquipmentSubCategories(
          formData.id,
          selectedSubCategories
        )
          .then((res) => {
            if (res.data.success) {
              subCategoriesUpdates = true;
            }
          })
          .catch((err) => {
            toast.error("Tags Error: " + err);
          });
      } else {
        subCategoriesUpdates = true;
      }
      setIsLoading(false);
      setButtonDisabled(false);
      if (equipmentUpdated && imageUpdated && subCategoriesUpdates) {
        toast.success("Save Success");
        navigate(`/equipment/${formData?.id}`);
      } else {
        toast.error("Error while saving");
      }
      return;
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      setButtonDisabled(false);
    }
  };

  const handleUpdateFromRimssClick = async () => {
    setButtonDisabled(true);
    try {
      setIsLoading(true);
      cleanValues(formData);
      await EquipmentApi.updateFromRimss(formData)
        .then((res) => {
          if (res.data.success) {
            toast.success("Successfully updated");
            getEquipment();
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          toast.error("Error: " + err);
          setIsLoading(false);
        });
      setIsLoading(false);
      setButtonDisabled(false);
      // if (equipmentUpdated && imageUpdated) {
      //   toast.success('Save Success');
      //   navigate(`/equipment/${formData?.id}`);
      // } else {
      //   toast.error('Error while saving');
      // }
      return;
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      setButtonDisabled(false);
    }
  };

  function handleRemoveImage(id: number) {
    const shouldRemove = window.confirm(
      "Are you sure you want to delete this image?"
    );

    if (shouldRemove) {
      CommonApi.deleteFile(id)
        .then((res) => {
          if (res.data.success) {
            setImageFiles(imageFiles.filter((x) => x.id !== id));
            toast.success("Image deleted");
          } else {
            toast.success("Error while deleting image");
          }
        })
        .catch((err) => {
          toast.error("Image Error: " + err);
        });
    }
  }

  function handleSetImagePrimary(id: number) {
    CommonApi.setFilePrimary(id)
      .then((res) => {
        if (res.data.success) {
          toast.success("Image set as Primary");
        } else {
          toast.success("Error while deleting image");
        }
      })
      .catch((err) => {
        toast.error("Image Error: " + err);
      });
  }

  return (
    <div className="w-full">
      <div className="w-full p-4">
        <div className="mx-1 flex items-end">
          <div className="flex flex-1">
            <h1 className="text-gray-900 font-bold text-4xl">
              Edit {EquipmentTypeStringEnums[equipmentType]} Information
            </h1>
          </div>
          <div className="right-2">
            <Link
              to={`/${EquipmentTypeStringEnums[equipmentType]}/${equipmentData?.id}`}
            >
              <Tooltip content="View">
                <Button className="buttonMain">
                  <HiEye size={20} />
                </Button>
              </Tooltip>
            </Link>
          </div>
        </div>
      </div>

      <div>
        <div className="container mx-auto p-2">
          <div className="md:flex no-wrap md:-mx-2 ">
            <div className="w-full md:w-3/12 md:mx-2">
              <div className="h-56 sm:h-64 xl:h-80 2xl:h-96 border-2 rounded-lg relative">
                {imageFiles && imageFiles.length === 0 && (
                  <img
                    src={blankImage}
                    alt={"blank-image"}
                    className="h-56 sm:h-64 xl:h-80 2xl:h-96 object-contain m-auto"
                  />
                )}
                {imageFiles && imageFiles.length > 0 && (
                  <img
                    key={
                      imageFiles.sort(
                        (a, b) => Number(b.isPrimary) - Number(a.isPrimary)
                      )[0].id
                    }
                    src={
                      imageFiles.sort(
                        (a, b) => Number(b.isPrimary) - Number(a.isPrimary)
                      )[0].fileUrl!
                    }
                    alt={formData.number + "-image"}
                    className="h-56 sm:h-64 xl:h-80 2xl:h-96 object-contain m-auto"
                  />
                )}
              </div>
            </div>
            <div className="w-full md:w-10/12 mx-2">
              <div className="bg-white p-3">
                <div className="flex items-center space-x-2 font-bold text-gray-500 leading-8 py-2">
                  <span className="tracking-wide uppercase text-3xl">
                    {equipmentData?.manufacturer?.name}
                  </span>
                </div>
                <hr className="bg-gray-300 h-[5px]"></hr>
                <Tabs style="fullWidth">
                  <Tabs.Item title="Info" className="font-bold">
                    <form id="editEquipmentForm" onSubmit={onSubmit}>
                      <div className="text-gray-500">
                        <div>
                          <Tooltip content="Update Info from RIMSS">
                            <Button
                              type="button"
                              className="buttonMain"
                              onClick={handleUpdateFromRimssClick}
                              disabled={buttonDisabled}
                            >
                              {/* <RxUpdate size={20}></RxUpdate> */}
                              Update from RIMSS
                            </Button>
                          </Tooltip>
                        </div>
                        <br />
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div
                              style={{ minHeight: 40 }}
                              className="font-bold content-center"
                            >
                              Manufacturer:
                            </div>
                          </div>
                          <div className="content-center">
                            {equipmentData?.manufacturer?.name}
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Categories:
                            </div>
                          </div>
                          <div
                            style={{ minHeight: 40 }}
                            className="content-center"
                          >
                            {equipmentData?.categoriesString &&
                              equipmentData?.categoriesString.map((x) => (
                                <div>{x}</div>
                              ))}
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Rimss Id:
                            </div>
                          </div>
                          <div>
                            <TextInput
                              id="rimssId"
                              name="rimssId"
                              type="text"
                              placeholder="Rimss Id..."
                              onChange={handleChangeInput}
                              value={formData.rimssId ?? ""}
                              sizing="md"
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Product Id:
                            </div>
                          </div>
                          <div>
                            <TextInput
                              id="productId"
                              name="productId"
                              type="text"
                              placeholder="Product Id..."
                              onChange={handleChangeInput}
                              value={formData.productId ?? ""}
                              sizing="md"
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Product Source:
                            </div>
                          </div>
                          <div>
                            <TextInput
                              id="productSource"
                              name="productSource"
                              type="text"
                              placeholder="productSource..."
                              onChange={handleChangeInput}
                              value={formData.productSource ?? ""}
                              sizing="md"
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Location Id:
                            </div>
                          </div>
                          <div>
                            <TextInput
                              id="locationId"
                              name="locationId"
                              type="text"
                              placeholder="Location Id..."
                              onChange={handleChangeInput}
                              value={formData.locationId ?? ""}
                              sizing="md"
                              disabled
                            />
                          </div>
                        </div>

                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Part Number:
                            </div>
                          </div>
                          <div>
                            <TextInput
                              id="number"
                              name="number"
                              type="text"
                              placeholder="Part Number..."
                              onChange={handleChangeInput}
                              value={formData.number ?? ""}
                              sizing="md"
                              required
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              OEM Vendor:
                            </div>
                          </div>
                          <div>
                            <TextInput
                              id="oemvendor"
                              name="oemvendor"
                              type="text"
                              placeholder="OEM Vendor..."
                              onChange={handleChangeInput}
                              value={formData.oemvendor ?? ""}
                              sizing="md"
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              OEM Division:
                            </div>
                          </div>
                          <div>
                            <TextInput
                              id="oemdivision"
                              name="oemdivision"
                              type="text"
                              placeholder="OEM Division..."
                              onChange={handleChangeInput}
                              value={formData.oemdivision ?? ""}
                              sizing="md"
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              PriceBook:
                            </div>
                          </div>
                          <div>
                            <TextInput
                              id="priceBook"
                              name="priceBook"
                              type="text"
                              placeholder="PriceBook..."
                              onChange={handleChangeInput}
                              value={formData.priceBook ?? ""}
                              sizing="md"
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Description (from Rimss):
                            </div>
                          </div>
                          <div>
                            <TextInput
                              id="description"
                              name="description"
                              type="text"
                              placeholder="Description..."
                              onChange={handleChangeInput}
                              value={formData.description ?? ""}
                              sizing="md"
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Full Description:
                            </div>
                          </div>
                          <div>
                            <Editor
                              id="fullDescription"
                              name="fullDescription"
                              value={quillValue}
                              className="w-full"
                              changedValue={setQuillValue}
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">UPC:</div>
                          </div>
                          <div>
                            <TextInput
                              id="upc"
                              name="upc"
                              type="text"
                              placeholder="UPC..."
                              onChange={handleChangeInput}
                              value={formData.upc ?? ""}
                              sizing="md"
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">SKU:</div>
                          </div>
                          <div>
                            <TextInput
                              id="sku"
                              name="sku"
                              type="text"
                              placeholder="SKU..."
                              onChange={handleChangeInput}
                              value={formData.sku ?? ""}
                              sizing="md"
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Primary Bin:
                            </div>
                          </div>
                          <div>
                            <TextInput
                              id="primaryBin"
                              name="primaryBin"
                              type="text"
                              placeholder="Primary Bin..."
                              onChange={handleChangeInput}
                              value={formData.primaryBin ?? ""}
                              sizing="md"
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Quantity on Hand:
                            </div>
                          </div>
                          <div>
                            <TextInput
                              id="quantityOnHand"
                              name="quantityOnHand"
                              type="text"
                              placeholder="Quantity on Hand..."
                              onChange={handleChangeInput}
                              value={formData.quantityOnHand ?? ""}
                              sizing="md"
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Quantity Committed:
                            </div>
                          </div>
                          <div>
                            <TextInput
                              id="quantityCommitted"
                              name="quantityCommitted"
                              type="text"
                              placeholder="Quantity Committed..."
                              onChange={handleChangeInput}
                              value={formData.quantityCommitted ?? ""}
                              sizing="md"
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Quantity on Order:
                            </div>
                          </div>
                          <div>
                            <TextInput
                              id="quantityOnOrder"
                              name="quantityOnOrder"
                              type="text"
                              placeholder="Quantity on Order..."
                              onChange={handleChangeInput}
                              value={formData.quantityOnOrder ?? ""}
                              sizing="md"
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Quantity Committed on Order:
                            </div>
                          </div>
                          <div className="w-1/2 content-center">
                            <TextInput
                              id="quantityCommittedOnOrder"
                              name="quantityCommittedOnOrder"
                              type="text"
                              placeholder="Quantity Committed on Order..."
                              onChange={handleChangeInput}
                              value={formData.quantityCommittedOnOrder ?? ""}
                              sizing="md"
                              disabled
                            />
                          </div>
                        </div>

                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Manufacturer List:
                            </div>
                          </div>
                          <div>
                            <TextInput
                              id="manufacturerList"
                              name="manufacturerList"
                              type="text"
                              placeholder="0.00"
                              onChange={handleChangeCurrencyInput}
                              onKeyDown={(event) => {
                                if (onlyNumberInput(event)) {
                                  event.preventDefault();
                                }
                              }}
                              value={formData.manufacturerList ?? ""}
                              sizing="md"
                              addon="$"
                              disabled
                            />
                          </div>
                        </div>

                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Product Class:
                            </div>
                          </div>
                          <div>
                            <TextInput
                              id="productClass"
                              name="productClass"
                              type="text"
                              placeholder="Product Class..."
                              onChange={handleChangeInput}
                              value={formData.productClass ?? ""}
                              sizing="md"
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Product Category:
                            </div>
                          </div>
                          <div>
                            <TextInput
                              id="productCategory"
                              name="productCategory"
                              type="text"
                              placeholder="Product Category..."
                              onChange={handleChangeInput}
                              value={formData.productCategory ?? ""}
                              sizing="md"
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Product Group:
                            </div>
                          </div>
                          <div>
                            <TextInput
                              id="productGroup"
                              name="productGroup"
                              type="text"
                              placeholder="Product Group..."
                              onChange={handleChangeInput}
                              value={formData.productGroup ?? ""}
                              sizing="md"
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Package Multiple:
                            </div>
                          </div>
                          <div>
                            <TextInput
                              id="packageMultiple"
                              name="packageMultiple"
                              type="text"
                              placeholder="Package Multiple..."
                              onChange={handleChangeInput}
                              value={formData.packageMultiple ?? ""}
                              sizing="md"
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Height:
                            </div>
                          </div>
                          <div>
                            <TextInput
                              id="height"
                              name="height"
                              type="text"
                              placeholder="Height..."
                              onChange={handleChangeInput}
                              value={formData.height ?? ""}
                              sizing="md"
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Width:
                            </div>
                          </div>
                          <div>
                            <TextInput
                              id="width"
                              name="width"
                              type="text"
                              placeholder="Width..."
                              onChange={handleChangeInput}
                              value={formData.width ?? ""}
                              sizing="md"
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Depth:
                            </div>
                          </div>
                          <div>
                            <TextInput
                              id="depth"
                              name="depth"
                              type="text"
                              placeholder="Depth..."
                              onChange={handleChangeInput}
                              value={formData.depth ?? ""}
                              sizing="md"
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Weight:
                            </div>
                          </div>
                          <div>
                            <TextInput
                              id="weight"
                              name="weight"
                              type="text"
                              placeholder="Weight..."
                              onChange={handleChangeInput}
                              value={formData.weight ?? ""}
                              sizing="md"
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Association Type:
                            </div>
                          </div>
                          <div>
                            <TextInput
                              id="associationType"
                              name="associationType"
                              type="text"
                              placeholder="Association Type..."
                              onChange={handleChangeInput}
                              value={formData.associationType ?? ""}
                              sizing="md"
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Cost Price:
                            </div>
                          </div>
                          <div>
                            <TextInput
                              id="cost"
                              name="cost"
                              type="text"
                              placeholder="0.00"
                              onChange={handleChangeCurrencyInput}
                              onKeyDown={(event) => {
                                if (onlyNumberInput(event)) {
                                  event.preventDefault();
                                }
                              }}
                              value={formData.cost ?? 0}
                              sizing="md"
                              addon="$"
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Public/List Price:
                            </div>
                          </div>
                          <div>
                            <TextInput
                              id="price"
                              name="price"
                              type="text"
                              placeholder="0.00"
                              onChange={handleChangeCurrencyInput}
                              onKeyDown={(event) => {
                                if (onlyNumberInput(event)) {
                                  event.preventDefault();
                                }
                              }}
                              value={formData.price ?? ""}
                              sizing="md"
                              addon="$"
                              disabled
                            />
                          </div>
                        </div>
                        {/* <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              List Price:
                            </div>
                          </div>
                          <div>
                            <TextInput
                              id="listPrice"
                              name="listPrice"
                              type="text"
                              placeholder="0.00"
                              onChange={handleChangeCurrencyInput}
                              onKeyDown={(event) => {
                                if (onlyNumberInput(event)) {
                                  event.preventDefault();
                                }
                              }}
                              value={formData.listPrice ?? ""}
                              sizing="md"
                              addon="$"
                              disabled
                            />
                          </div>
                        </div> */}
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Trade Price:
                            </div>
                          </div>
                          <div>
                            <TextInput
                              id="tradePrice"
                              name="tradePrice"
                              type="text"
                              placeholder="0.00"
                              onChange={handleChangeCurrencyInput}
                              onKeyDown={(event) => {
                                if (onlyNumberInput(event)) {
                                  event.preventDefault();
                                }
                              }}
                              value={formData.tradePrice ?? ""}
                              sizing="md"
                              addon="$"
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">FTL:</div>
                          </div>
                          <div>
                            <TextInput
                              id="special1Price"
                              name="special1Price"
                              type="text"
                              placeholder="0.00"
                              onChange={handleChangeCurrencyInput}
                              onKeyDown={(event) => {
                                if (onlyNumberInput(event)) {
                                  event.preventDefault();
                                }
                              }}
                              value={formData.special1Price ?? ""}
                              sizing="md"
                              addon="$"
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">NET:</div>
                          </div>
                          <div>
                            <TextInput
                              id="special2Price"
                              name="special2Price"
                              type="text"
                              placeholder="0.00"
                              onChange={handleChangeCurrencyInput}
                              onKeyDown={(event) => {
                                if (onlyNumberInput(event)) {
                                  event.preventDefault();
                                }
                              }}
                              value={formData.special2Price ?? ""}
                              sizing="md"
                              addon="$"
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Special 3 Price:
                            </div>
                          </div>
                          <div>
                            <TextInput
                              id="special3Price"
                              name="special3Price"
                              type="text"
                              placeholder="0.00"
                              onChange={handleChangeCurrencyInput}
                              onKeyDown={(event) => {
                                if (onlyNumberInput(event)) {
                                  event.preventDefault();
                                }
                              }}
                              value={formData.special3Price ?? ""}
                              sizing="md"
                              addon="$"
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Inactive:
                            </div>
                          </div>
                          <div>
                            <Checkbox
                              id="inactive"
                              name="inactive"
                              onChange={handleChangeCheckboxInput}
                              checked={formData.inactive ?? false}
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[20%_80%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Pricing UoM:
                            </div>
                          </div>
                          <div>
                            <TextInput
                              id="pricingUoM"
                              name="pricingUoM"
                              type="text"
                              placeholder="Pricing UoM..."
                              onChange={handleChangeInput}
                              value={formData.pricingUoM ?? ""}
                              sizing="md"
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                    </form>
                  </Tabs.Item>
                  <Tabs.Item title="Images" className="font-bold">
                    {id && <EquipmentImages equipmentId={Number(id)} />}
                  </Tabs.Item>
                  <Tabs.Item title="Videos" className="font-bold">
                    {id && <EquipmentVideoList equipmentId={Number(id)} />}
                  </Tabs.Item>
                  <Tabs.Item title="Features" className="font-bold">
                    {id && <EquipmentFeatureList equipmentId={Number(id)} />}
                  </Tabs.Item>
                  <Tabs.Item title="Files" className="font-bold">
                    {id && <EquipmentFiles equipmentId={Number(id)} />}
                  </Tabs.Item>
                </Tabs>

                <div className="flex justify-end pt-2">
                  <Button
                    disabled={buttonDisabled}
                    type="submit"
                    className="buttonMain"
                    form="editEquipmentForm"
                  >
                    Save
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
